<template>
<div id="publication-list">
    <div class="publication_fig">
        <img :src="getImageUrl(item.figname)" width="100%">
    </div>
    <div class="publication_description">
        <h1 @click="onClick" @mouseover="active=true" @mouseleave="active=false">
            {{item.name}}
        </h1>
        <span v-for="(i, index) in item.authors" :key="index">
            <span v-if="i === 'Man Ho Lam'"><strong>{{ i }}</strong></span>
            <span v-else>{{ i }}</span>
            <span v-if="index < item.authors.length - 1">, </span>
        </span>
        <h2 v-html="item.conference"></h2>
        <div class="resources-container">
            <a v-if="item.websiteLink" :href="item.websiteLink" rel="noopener noreferrer"><i class="fas fa-globe"></i>Website</a>
            <a v-if="item.conference" :href="item.paperLink" rel="noopener noreferrer"><i class="ai ai-arxiv"></i>{{ item.paper }}</a>
            <a v-if="item.codeLink" :href="item.codeLink" rel="noopener noreferrer"><i class="fab fa-github"></i>Code</a>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'PublicationItem',
    props: ['item', 'index', 'itemStatus', 'switchStatus'],
    data() {
        return {
            height: 1000,
            collapse: true,
            active: false,
            status: 'collapsed'
        }
    },
    methods: {
        onClick(){
            this.active = true
            this.switchStatus(this.index)
        },
        getImageUrl(figname) {
            return require(`@/assets/publication//${figname}`);
        },
    }
}
</script>

<style scoped>

#publication-list {
    width: 100%;
    display: flex;
    align-items: flex-start;
    margin-bottom: 25px;
}
.publication_fig {
    width: 33%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    box-sizing: border-box;
}
.publication_description {
    height: 100%;
    width: 66%;
    text-align: left;
    padding: 0 20px;
    margin: 0;
}


h1{
    font-size: 23px;
    line-height: 1.5;
    margin: 10px 0;
    font-family: 'Times New Roman', Times, serif;
    font-weight: 1000;
    text-align: left;
}
span{
    font-size: 19px;
    line-height: 1.5;
}

h2{
    font-size: 19px;
    line-height: 2;
}
strong{
    font-weight: 800
}
.resources-container{
    margin: 10px 0;
    text-align: left;
}
.resources-container h2{
    text-align: left;
}
a{
    font-size: 19px;
    display: inline-block;
    font-weight: normal;
    margin-right: 50px;
    cursor: pointer;
    text-decoration: none;
    color: rgb(24, 24, 24);
}
a:hover{
    text-decoration: underline;
    color: #2855c7;
}
a i{
    margin-right: 5px;
}
h4{
    display: inline-block;
    height: 20px;
    font-size: 15px;
    margin-right: 10px;
    font-weight: bold;
}

/* Conference badge styles */
:deep(.conf-badge) {
    display: inline-block;
    padding: 2px 10px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 5px;
    background-color: #dbeafe;
    color: #1d4ed8;
    border: 1px solid #93c5fd;
    text-decoration: none;
}
:deep(.conf-badge:hover) {
    background-color: #bfdbfe;
    text-decoration: none;
}
:deep(.conf-badge-oral) {
    margin-left: 8px;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 4px;
    background-color: #fee2e2;
    color: #dc2626;
    border: 1px solid #fca5a5;
}
</style>